import { LegalEntityEnum } from '../legal-entity.enum';
import { CaseImageType } from './case-image-type.enum';
import { ProductMainGroups } from './product-main-group.enum';

export const IMAGE_UPLOAD_REQUIRED_LEGAL_ENTITIES: Set<LegalEntityEnum> = new Set([
  LegalEntityEnum.ON_AG,
  LegalEntityEnum.ON_UK,
  LegalEntityEnum.ON_CH,
]);

export const REQUIRED_WARRANTY_IMAGE_TYPES: Record<ProductMainGroups, CaseImageType[]> = {
  [ProductMainGroups.shoes]: [CaseImageType.SolesShoe, CaseImageType.InnerTagShoe, CaseImageType.DefectShoes],
  [ProductMainGroups.apparel]: [CaseImageType.InnerTagApparel, CaseImageType.DefectApparel],
  [ProductMainGroups.accessories]: [CaseImageType.InnerTagAccessories, CaseImageType.DefectAccessories],
};

/**
 * Maximum total units (sum of line quantities) in a warranty case. Each unit becomes its own
 * warranty form and Salesforce line, with up to 4 images each.
 */
export const MAX_WARRANTY_CASE_ITEMS = 50;

/** Maximum total units (sum of line quantities) in a return case, applied to all legal entities. */
export const MAX_RETURN_CASE_ITEMS = 500;
